<template>
  <component class="inst-log layout" :class="line()" :is="component" :log="log">
    <span v-if="badge" class="badge iconfont" :class="badge" slot="badge"></span>
  </component>
</template>

<script>
import LogGroup from "./log-group";
import LogNotify from "./log-notify";
import LogUser from "./log-user";

export default {
  name: "log-virtual",
  props: ["log"],
  computed: {
    badge() {
      if (this.log.activate === "notify" && this.log.state !== -2) {
        return "icon-wf-pass";
      }
      if (this.log.state === -3) {
        return "icon-wf-forward";
      } else if (this.log.state === -1) {
        return "icon-wf-current";
      } else if (this.log.state === 1) {
        return "icon-wf-pass";
      } else if (this.log.state === 0) {
        return "icon-wf-reject";
      } else if (this.log.state === 3) {
        return "icon-wf-revoke";
      }
      return "";
    },

    component() {
      if (this.log.activate === "notify") {
        return LogNotify;
      } else if (this.log.items.length === 1) {
        return LogUser;
      }
      return LogGroup;
    }
  },
  methods: {
    line() {
      if (this.log.activate === "notify" && this.log.state !== -2) {
        return "wf-pass";
      }
      switch (this.log.state) {
        case -3:
        case 1:
        case 0:
        case 3:
        case -1:
          return "wf-pass";
        default:
          return "wf-current";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.inst-log {
  padding: 10px 20px;
}
</style>


<style lang="scss">
@import "../../../../assets/css/global";
.switch-mobile{
  .inst-log{
    padding:10px 20px 10px 18px;
  }
}
.inst-log {
  .log-icon,
  .participant-icon {
    position: relative;
    .badge {
      position: absolute;
      font-size: 1.2rem;
      padding: 1px;
      background-color: $color-bg;
      right: -3px;
      bottom: -3px;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      line-height: 12px;
      text-align: center;
    }
    .icon-wf-pass {
      color: $color-success;
    }
  }
  .log-icon {
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    text-align: center;
    background-color: $color-primary;
    color: $color-bg;
    font-size: 1.6rem;
    padding: 0 5px;
    margin-right: 10px;
    &.large-logo {
      font-size: 2.4rem;
    }
    .icon-wf-forward {
      color: $color-primary;
    }

    .icon-wf-reject {
      color: $color-error;
    }
    .icon-wf-current {
      color: $color-warn;
    }
    .icon-wf-revoke {
      color: $color-font-light;
    }
  }

  .log-node-name {
    font-size: 1.6rem;
    color: $color-font-deep;
  }
  .log-participant {
    font-size: 1.4rem;
    color: $color-font-light;
  }
  .participant-list {
    flex-wrap: wrap;
    .participant {
      margin: 5px 15px 5px 0;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      .participant-icon {
        margin: 0 auto;
        border-radius: 50%;
        text-align: center;
        background-color: $color-primary;
        color: $color-bg;
        padding: 0 5px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        font-size: 1.2rem;
      }
      .participant-desc {
        font-size: 1.3rem;
        color: $color-font-light;
      }
    }
  }
  .log-date {
    width: 100px;
    color: #ccc;
    text-align: right;
    overflow: hidden;
    line-height: 20px;
  }

  .toggle-expand {
    color: #ccc;
    cursor: pointer;
  }
}

.switch-mobile {
  .inst-log {
    $node-height: 80px;
    $point-size: 12px;
    $line-left: 40px;
    $point-top: ($node-height - $point-size)/2;

    .relate-table {
      padding-left: 50px;
    }

    position: relative;
    .log-icon {
      width: 43px;
      height: 43px;
      line-height: 40px;
      border: 2px solid #fff;
    }

    &:before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: $line-left;
      border-left: 2px solid $color-border;
    }

    &.wf-current::before {
      border-left: 2px dashed $color-border;
    }
    &:first-child {
      &:before {
        top: $point-top;
      }
      &:last-child {
        &:before {
          display: none;
        }
      }
    }
    &:last-child {
      border-bottom: none;
      &:before {
        bottom: auto;
        height: $point-top;
      }
    }
  }
  .log-date {
    font-size: 1.2rem;
  }
}
</style>
